<!--完成付款弹窗形式 采购 付款 -->
<template>
    <div v-loading="loading" class="c-content">
        <el-form :rules="rules" :model="submitData" label-width="120px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="付款金额" label-width="80px">
                            <el-input v-model="allMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="已付金额" label-width="80px">
                            <el-input v-model="hjMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="实付金额" prop="ActualMoney" label-width="80px">
                            <el-input
                                ref="acmoney"
                                type="number"
                                step="1"
                                v-model="submitData.ActualMoney"
                                :min="0"
                                :disabled="!isCanEdit"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType" label-width="80px">
                            <el-select
                                v-model="submitData.PayType"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in payWayList"
                                    :key="item.Value"
                                    :label="item.Text"
                                    :value="item.Value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="付款日期" label-width="80px">
                            <el-date-picker
                                v-model="submitData.PayTime"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                style="width:100%"
                            ></el-date-picker>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注" label-width="80px">
                            <el-input v-model="submitData.Remark"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click="submitForm()"
                :disabled="!canSubmit"
            >提交确认</el-button>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["applyList", "dataLength", "settleId"],
  components: {},
  data() {
    return {
      allMoney: 0,
      hjMoney: 0,
      payWayList: [],
      loading: false,
      isCanEdit: true,
      submitData: {
        RecordIds: [],
        ActualMoney: "",
        PayType: "",
        Remark: "",
        PayTime: "",
        SettleId: "",
        OPType: 1 //0 是确认收款的 1是确认付款
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "blur" }],
        ActualMoney: [{ required: true, message: "该项必填", trigger: "blur" }]
      },
      canSubmit: true // 是否可以提交
    };
  },
  created: function() {
    var aData = new Date();
    this.submitData.PayTime =
      aData.getFullYear() +
      "-" +
      (aData.getMonth() + 1) +
      "-" +
      aData.getDate();
  },
  mounted() {
    if (this.applyList && this.applyList.length > 0 && this.settleId) {
      let applyAmountTotal = 0;
      let alreadyPaidTotal = 0;
      this.applyList.forEach(ele => {
        if (ele.OrderType == 0) {
          applyAmountTotal = (Number(applyAmountTotal)+ Number(ele.ApplyAmount)).toFixed(2);
          alreadyPaidTotal = (Number(alreadyPaidTotal)+ Number(ele.AlreadyPaid)).toFixed(2);
        } else {
          applyAmountTotal = (Number(applyAmountTotal)-Number(ele.ApplyAmount)).toFixed(2);
          alreadyPaidTotal = (Number(alreadyPaidTotal)-Number(ele.AlreadyPaid)).toFixed(2);
        }


        this.submitData.RecordIds.push(ele.RecordId);
      });

      if (this.applyList.length == 1) this.isCanEdit = true;
      else this.isCanEdit = false;

      this.allMoney = applyAmountTotal;
      this.hjMoney = alreadyPaidTotal;
      this.submitData.ActualMoney = (
        applyAmountTotal - alreadyPaidTotal
      ).toFixed(2);
      this.submitData.SettleId = this.settleId;
      this.getPay();
    } else {
      this.$util.warningMsg("要确认付款数据异常，请刷新后重新操作");
    }
    if (this.$refs.acmoney && this.isCanEdit) this.$refs.acmoney.focus();
  },
  methods: {
    cancel() {
      this.$emit("closeDialog");
    },
    submitForm() {
      if (this.submitData.RecordIds.length == 0) {
        this.$util.warningMsg("要确认付款数据异常，请刷新后重新操作");
        return;
      }
      if(this.submitData.ActualMoney == 0){
          this.$util.warningMsg("实付金额不能等于0");
        return;
      }
      this.$refs["submitData"].validate(valid => {
        if (valid) {
          this.canSubmit = false;
          this.$util
            .axiosPost({
              url: "/api/RevenueManagement_N/ConfirmPRForSettlementsDetails",
              data: this.submitData
            })
            .then(res => {
              this.$util.successMsg(res.errmsg);
              this.$emit("closeDialog", true);
            })
            .catch(() => {
              this.canSubmit = true;
            });
        } else {
          return false;
        }
      });
    },
    //  结算方式
    getPay() {
      this.$util.getPay(1).then(data => {
        this.payWayList = data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.c-content {
  margin-top: 10px;
}
.btn-ctn {
  text-align: right;
  padding-bottom: 10px;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
